import { render, staticRenderFns } from "./RepublicArmy.vue?vue&type=template&id=7f480095&scoped=true"
import script from "./RepublicArmy.vue?vue&type=script&lang=js"
export * from "./RepublicArmy.vue?vue&type=script&lang=js"
import style0 from "./RepublicArmy.vue?vue&type=style&index=0&id=7f480095&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f480095",
  null
  
)

export default component.exports